// Ortam degerleri production'da env-config.js ile runtime'da gelir (k8s Secret/ConfigMap'ten
// mount edilir). Boylece ayni image her ortamda calisir. Local'de dosya yoksa build-time
// process.env degerleri (.env.local) kullanilir.

declare global {
  interface Window {
    __DISPATCH_ENV__?: Record<string, string | undefined>;
  }
}

let loading: Promise<void> | undefined;

export function loadRuntimeEnv(): Promise<void> {
  if (!loading) {
    loading = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `/env-config.js?v=${Date.now()}`;
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });
  }

  return loading;
}

export function runtimeEnv(key: string, buildTimeValue?: string): string | undefined {
  return window.__DISPATCH_ENV__?.[key] ?? buildTimeValue;
}
